import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleErrorResponse } from "../../apis";
import axios from "axios";

export const getFabricLabelsDispatch = createAsyncThunk(
  "getFabricLabelsDispatch",
  async (data, { rejectWithValue }) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/get-fabric-labels/dispatch`;
    try {
      const response = await axios.post(URL, data);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `fabric_label.pdf`);
      document.body.appendChild(link);
      link.click();
      return response;
    } catch (error) {
      return handleErrorResponse(error, rejectWithValue);
    }
  }
);
